import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class SmoothScroll {
	constructor() {
		if (SmoothScroll.instance) return SmoothScroll.instance

		this._lenis = null
		this.options = {}
		this.#init()

		SmoothScroll.instance = this
	}

	#init() {
		this.#registerScrollTrigger()
		this.#initLenis()
		this.#addGsapTicker()
	}

	#initLenis() {
		this.options = { allowNestedScroll: true }
		this._lenis = new Lenis(this.options)
	}

	#addGsapTicker() {
		this._lenis.on('scroll', ScrollTrigger.update)
		gsap.ticker.add(time => {
			this._lenis.raf(time * 1000)
		})
		gsap.ticker.lagSmoothing(0)
	}

	#registerScrollTrigger() {
		gsap.registerPlugin(ScrollTrigger)
	}

	reset() {
		this._lenis?.scrollTo(0, { immediate: true, force: true })
		this._lenis?.resize()
	}

	get lenis() {
		return this._lenis
	}
}
